export class ObjectStoreService {
    static map = new Map();

    static set = (data, key) => {
        const dataKey = key ?? Date.now().toString(36);

        this.map.set(dataKey, data);

        return dataKey;
    };
    static get = (key) => this.map.get(key);
    static has = (key) => this.map.has(key);
    static delete = (key) => this.map.delete(key);
    static pull = (key) => {
        const value = this.map.get(key);

        if (this.map.has(key)) {
            this.map.delete(key);
        }

        return value;
    };
}
